import { useEffect, useRef, useState } from 'react';
import { EXPERIMENTS } from '../../constants/experiments';
import { useExperiments } from '../../contexts/experiments-context';
export const SLOT_UNAVAILABLE_REASON = 'SLOT_UNAVAILABLE';
const NO_REJECTED_SLOTS = [];
const isSlotUnavailable = (error)=>error?.params?.reason === SLOT_UNAVAILABLE_REASON;
/** Start dates of slots the server rejected as taken, for the picker to drop. */ export const useSlotRejection = ({ error, selectedSlot })=>{
    const { isExperimentEnabled } = useExperiments();
    const isSlotHoldEnabled = isExperimentEnabled(EXPERIMENTS.BIF_SLOT_HOLD);
    const [rejectedSlotStartDates, setRejectedSlotStartDates] = useState(NO_REJECTED_SLOTS);
    const isRejected = isSlotHoldEnabled && isSlotUnavailable(error);
    const startDate = selectedSlot?.startDate;
    // The error stays on the field until revalidation drops it, so latch one rejection to one
    // slot — otherwise a slot picked while it is still up gets rejected too.
    const hasHandledRejection = useRef(false);
    useEffect(()=>{
        if (!isRejected) {
            hasHandledRejection.current = false;
            return;
        }
        if (hasHandledRejection.current) {
            return;
        }
        hasHandledRejection.current = true;
        if (!startDate) {
            return;
        }
        setRejectedSlotStartDates((rejected)=>rejected.includes(startDate) ? rejected : [
                ...rejected,
                startDate
            ]);
    }, [
        isRejected,
        startDate
    ]);
    return isSlotHoldEnabled ? rejectedSlotStartDates : NO_REJECTED_SLOTS;
};

//# sourceMappingURL=use-slot-rejection.js.map